/**
 * UI feature visibility toggles.
 *
 * Set a flag to `true` to show a section/route/nav item, or `false` to hide it.
 * Code stays in place — only rendering is gated.
 *
 * Usage:
 *   import { featureVisibility } from '../config/featureVisibility';
 *   {featureVisibility.home.platformCapabilities && ( ... )}
 */

export const featureVisibility = {
  home: {
    /** Home page "Platform Capabilities" block (community, AI, accessibility cards, partnerships). */
    platformCapabilities: false,
  },

  nav: {
    tools: {
      quiz: false,
      shortNotes: false,
      learn: false,
      badges: false,
    },
  },

  language: {
    /** Language selector: show English option (set true to re-enable). */
    showEnglish: false,
  },

  multimedia: {
    audioGuides: {
      /** Multilingual Audio Guides: show Hindi option (set true to re-enable). */
      showHindi: false,
    },
  },
};
